import { LOAD_SEASON_STATS } from "../actions";

export const initialState = null;

export type StatsState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case LOAD_SEASON_STATS: {
			return action.stats;
		}

		default:
			return state;
	}
}
